import actions from 'src/modules/resource/lock/resourceLockActions';

type LockStatus =
  | 'idle'
  | 'acquiring'
  | 'held'
  | 'held-by-other'
  | 'error';

type State = {
  status: LockStatus;
  owned: boolean;
  lockedAt: string | null;
  expiresAt: string | null;
  ttlSec: number | null;
  holder: { id: string; fullName: string } | null;
  error: string | null;
};

const initialData: State = {
  status: 'idle',
  owned: false,
  lockedAt: null,
  expiresAt: null,
  ttlSec: null,
  holder: null,
  error: null,
};

type Action = {
  type: string;
  payload?: {
    force?: boolean;
    owned?: boolean;
    lockedAt?: string;
    expiresAt?: string;
    lockTtlSec?: number;
    editingBy?: { id: string; fullName: string };
    editingLockedAt?: string;
    error?: string | null;
  };
};

export default (
  state: State = initialData,
  { type, payload }: Action,
): State => {
  if (type === actions.RESETED) {
    return { ...initialData };
  }

  if (type === actions.ACQUIRE_STARTED) {
    return { ...state, status: 'acquiring', error: null };
  }

  if (type === actions.ACQUIRE_SUCCESS) {
    return {
      ...state,
      status: 'held',
      owned: true,
      lockedAt: payload?.lockedAt ?? null,
      expiresAt: payload?.expiresAt ?? null,
      ttlSec: payload?.lockTtlSec ?? null,
      holder: null,
      error: null,
    };
  }

  if (type === actions.ACQUIRE_HELD_BY_OTHER) {
    return {
      ...state,
      status: 'held-by-other',
      owned: false,
      lockedAt: payload?.editingLockedAt ?? null,
      expiresAt: null,
      ttlSec: null,
      holder: payload?.editingBy ?? null,
      error: null,
    };
  }

  if (type === actions.ACQUIRE_ERROR) {
    return {
      ...state,
      status: 'error',
      owned: false,
      error: payload?.error ?? null,
    };
  }

  if (type === actions.RELEASE_SUCCESS) {
    return { ...initialData };
  }

  return state;
};
